import { render, staticRenderFns } from "./LoadingNew.vue?vue&type=template&id=0c955226&scoped=true&"
import script from "./LoadingNew.vue?vue&type=script&lang=js&"
export * from "./LoadingNew.vue?vue&type=script&lang=js&"
import style0 from "./LoadingNew.vue?vue&type=style&index=0&id=0c955226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c955226",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
